import LoadingIcon from './LoadingIcon'

import styles from './Loading.module.css'

function Loading() {
  return (
    <div className={styles.root}>
      <LoadingIcon className={styles.icon} />
    </div>
  )
}

export default Loading
